import { registerLinkResolver } from "gatsby-source-prismic-graphql";
import linkResolver from "./src/utils/linkResolver";
import LocaleWrap from "./wrapPageElement";

registerLinkResolver(linkResolver);
export const wrapPageElement = LocaleWrap;
